
import React from 'react';
import SmartCard from './index';
import { Tabs } from '@platform/base';
const { TabPane } = Tabs;
import './runtime.less';

const { CardWallet } = SmartCard;

function SmartCardComponent (props) {
    let { _pageScope, moduleId, ...others } = props;
    return _pageScope.props.smartCard.createSmartCard(moduleId, others);
    
}

function SmartCardContainer(props) {
    let { rightArea, isLowCode, moduleId, tabs = [], visible, showRefresh, ...others } = props;
    if (!visible) {
        return null;
    }
    
    let items = tabs.map(tab => {
        let { moduleId, name, cards = [] } = tab;
        return <TabPane
            key={moduleId}
            tab={name}
            className='lc-drop-area smart-card-container-item'
        >
            {cards.map(({ moduleId, children, ...others }) => <CardWallet key={moduleId} className={`card-wallet-${moduleId} lc-smart-card-wallet`} _design={true} {...others}>
                {children}
            </CardWallet>)}
        </TabPane >;
    });
    return <Tabs
        className='smart-card-container'
        {...others}
        extraContent={<div className='tab-rightarea'>{showRefresh && <i className='iconfont icon-danchuangshuaxin'></i>}{rightArea}</div>}
    >
        {items}
    </Tabs>;
}

function SmartCardWallet (props) {
    let { children, className, ...others } = props;
    return <CardWallet className={`${className}  lc-smart-card-wallet`} {...others} >{children}</CardWallet>;    
}

export { SmartCardContainer, SmartCardWallet } ;
export default SmartCardComponent;
